module.exports = __webpack_public_path__ + "img/horizontal_4_1_6000.98dce525.png";